import { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import apiClient from "../../apiClient";
import { GROUP_BREADCRUMB, USER_DETAILS } from "../../apiClient/apiEndpoints";
import { useNavigate } from "react-router-dom";

const { Breadcrumbs: UIBreadcrumb } = UiComponents;

const Breadcrumbs = ({ UUID, UNO_URL, activeCrumb, isUser = false }) => {
  const [breadcrumbList, setBreadcrumbList] = useState([]);
  const navigate = useNavigate();
const getGroupBreadcrumb = async () => {
    try {
      let data = await apiClient.get(`${UNO_URL}${GROUP_BREADCRUMB}/${UUID}`);
      let list = data || [];
      if (isUser) {
        getUserBreaCrumb(list);
      } else {
        setBreadcrumbList(list.reverse());
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUserBreaCrumb = async (list) => {
    try {
      const data = await apiClient.get(`${UNO_URL}${USER_DETAILS}/${UUID}`);
      setBreadcrumbList(list.reverse());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getGroupBreadcrumb();
  }, [UUID]);

  const handleBreadCrumbClick = (key) => {
    navigate(`/team-management/${key.key}`);
  };

  return <UIBreadcrumb data={breadcrumbList} handleClick={handleBreadCrumbClick} activeCrumb={activeCrumb} />;
};

export default Breadcrumbs;
